<ng-container *ngIf="!select && !userSubprojects">
  <li class="srch-li" #searchSubproject *ngIf="this.globals.subprojects.length">
    <div data-cy="generic-multiselect-subprojects__page" class="search-box-container">
      <i class="uil uil-search uil-icon"></i>
      <input data-cy="generic-multiselect-subprojects__search-box-input" class="search-box"
        placeholder="{{'text.search_in_subprojects' | transloco}}" [value]="searchTerm" (keyup)="onSearchInput($event)">
    </div>
  </li>

  <!-- Tree View -->
  <li class="tree-list">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="width: 100%;">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" [style.background-color]="node?.tenant_type==='shared'?'#f0f0f0':''"
        [class.selected-subproject-node]="isActiveSubProject(node)">
        <span class="top-lvl">
          <div *ngIf="node?.tenant_type==='shared' && node.is_first_shared" class="external-heading">
            <i class="uil uil-share-alt"></i>
            <h3>Extern gedeelde projecten</h3>
          </div>
          <mat-divider [class.t-mrg]="treeControl.getLevel(node) == 0"></mat-divider>
          <div class="node-wrapper">
            <button type="button" class="subproject-radio" [class.selected]="isActiveSubProject(node)"
              [attr.aria-label]="'Select ' + node.name" [attr.aria-pressed]="isActiveSubProject(node)"
              (click)="switchProject.emit(node.id)"></button>
            <div class="node p-node" [style]="{'padding-left': treeControl.getLevel(node) * 21 + 'px !important'}">
              <span data-cy="generic-multiselect-subprojects__action" class="node pointer"
                (click)="switchProject.emit(node.id)">
                <span class="node-wrapper" style="position: relative;">
                  <div class="vertical-line dots-position" *ngIf="treeControl.getLevel(node) >= 0"></div>
                  <div class="vertical-line dots-position ml-dots"
                    *ngIf="(treeControl.getLevel(node) == 3 && !isChildOfLastSibling(node)) || (treeControl.getLevel(node) == 4 && !isGrandparentLastSibling(node))"
                    [style.left]="treeControl.getLevel(node) ==3 ? '-17px !important' : '-38px !important'"></div>
                  <div class="vertical-line dots-position ml-dots"
                    *ngIf="treeControl.getLevel(node) == 4 && !isChildOfLastSibling(node)"></div>
                  <div class="vertical-line dots-position left-dots-lvl-gt1"
                    *ngIf="( treeControl.getLevel(node) == 4 && !isGreatGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 3 && !isGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 2 && !isChildOfLastSibling(node))"
                    [style.left]="treeControl.getLevel(node) ==2 ? '-17px !important' : treeControl.getLevel(node) == 3 ? '-38px !important':'-59px !important'">
                  </div>
                  <div class="vertical-line dots-position bottom-below-half-dots"
                    *ngIf="treeControl.getLevel(node) >= 0 && !isLastSibling(node)"></div>
                  <div class="horizontal-line" *ngIf="treeControl.getLevel(node) >= 0"></div>
                  <ngx-avatars [style]="AvatarCustomStyle" [name]="node.name" initialsSize="2" size="30"
                    [borderColor]="node.color" fgColor="#000000" bgColor="#FFFFFF">
                  </ngx-avatars>
                </span>
                <!-- use a disabled button to provide padding for tree leaf -->
                <!-- <button mat-icon-button disabled></button> -->
                <span class="fs-13">{{node.name}}</span>
              </span>
              <span class="node" *ngIf="!node?.is_external && node?.tenant_type!=='shared'">
                <p class="lvl-p"
                  *ngIf="globals && globals.projectConfigs && (globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] || this.globals.projectConfigs['project.labels.subprojects'])">
                  {{ globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] ?
                  globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)]:
                  this.globals.projectConfigs['project.labels.subprojects'] }}
                </p>
                <mat-icon data-cy="generic-multiselect-subprojects__edit" *hasPermission="[Permission.SubprojectUpdate]"
                  [class]="'edit-icon pointer edit-subproject-btn-'+node.id" (click)="edit(node)"
                  matTooltip="{{ ('subprojects.edit' | transloco) + ' ' + (this.globals.projectConfigs['project.labels.subprojects'] || 'subprojects.label_small' | transloco) }}">edit</mat-icon>
                <mat-icon class="mat-icon-rtl-mirror pointer" matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.name" style="visibility: hidden;">
                  {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                </mat-icon>
              </span>
            </div>
          </div>
        </span>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" [class.selected-subproject-node]="isActiveSubProject(node)">
        <span class="top-lvl">
          <mat-divider [class.t-mrg]="treeControl.getLevel(node) == 0"></mat-divider>
          <div class="node-wrapper">
            <button type="button" class="subproject-radio" [class.selected]="isActiveSubProject(node)"
              [attr.aria-label]="'Select ' + node.name" [attr.aria-pressed]="isActiveSubProject(node)"
              (click)="switchProject.emit(node.id)"></button>
            <div class="node p-node" [style]="{'padding-left': treeControl.getLevel(node) * 21 + 'px !important'}">
              <span data-cy="generic-multiselect-subprojects__action-2" class="node pointer"
                (click)="switchProject.emit(node.id)">
                <span class="node-wrapper" style="position: relative;">
                  <div class="vertical-line dots-position" *ngIf="treeControl.getLevel(node) >= 0"></div>
                  <div class="vertical-line dots-position ml-dots"
                    *ngIf="(treeControl.getLevel(node) == 3 && !isChildOfLastSibling(node)) || (treeControl.getLevel(node) == 4 && !isGrandparentLastSibling(node))"
                    [style.left]="treeControl.getLevel(node) ==3 ? '-17px !important' : '-38px !important'"></div>
                  <div class="vertical-line dots-position ml-dots" *ngIf="treeControl.getLevel(node) == 4"></div>
                  <div class="vertical-line dots-position left-dots-lvl-gt1"
                    *ngIf="( treeControl.getLevel(node) == 4 && !isGreatGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 3 && !isGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 2 && !isChildOfLastSibling(node))"
                    [style.left]="treeControl.getLevel(node) ==2 ? '-17px !important' : treeControl.getLevel(node) == 3 ? '-38px !important':'-59px !important'">
                  </div>
                  <div class="vertical-line dots-position bottom-below-half-dots"
                    *ngIf="treeControl.getLevel(node) >= 0 && !isLastSibling(node)"></div>
                  <div class="vertical-line dots-position mid-dots"
                    [class.mid-dots-lvl1]="treeControl.getLevel(node) == 0" *ngIf="treeControl.isExpanded(node)"></div>
                  <div class="horizontal-line" *ngIf="treeControl.getLevel(node) >= 0"></div>
                  <ngx-avatars [style]="AvatarCustomStyle" [name]="node.name" initialsSize="2" size="30"
                    [borderColor]="node.color" fgColor="#000000" bgColor="#FFFFFF">
                  </ngx-avatars>
                </span>
                <span class="fs-13">{{node.name}}</span>
              </span>
              <span class="node">
                <p class="lvl-p"
                  *ngIf="globals && globals.projectConfigs && (globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] || this.globals.projectConfigs['project.labels.subprojects'])">
                  {{ globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] ?
                  globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)]:
                  this.globals.projectConfigs['project.labels.subprojects'] }}
                </p>
                <mat-icon data-cy="generic-multiselect-subprojects__edit-2"
                  *hasPermission="[Permission.SubprojectUpdate]"
                  [class]="'edit-icon pointer edit-subproject-btn-'+node.id" (click)="edit(node)"
                  matTooltip="{{ ('subprojects.edit' | transloco) + ' ' + (this.globals.projectConfigs['project.labels.subprojects'] || 'subprojects.label_small' | transloco) }}">edit</mat-icon>

                <mat-icon class="mat-icon-rtl-mirror pointer" matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.name">
                  {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                </mat-icon>
              </span>
            </div>
          </div>
        </span>
      </mat-tree-node>
    </mat-tree>
  </li>
</ng-container>

<ng-container *ngIf="select && !userSubprojects">
  <div [class]="!select || !multiSelect && 'dropdown-container'">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{label=== 'Subproject' ? (this.globals.projectConfigs['project.labels.subprojects'] ||
        'subprojects.label' | transloco): label}}</mat-label>
      <input data-cy="generic-multiselect-subprojects__field-input" #mySelect matInput
        [class]="'add-subproject ' + uniqueId" disabled="{{ disabled }}" #subprojectInput (focus)="onFocusInput()"
        (click)="showDropdown = true" [matChipInputFor]="chipGrid" [value]="searchTerm"
        (keyup)="onSearchInput($event)" />
      <mat-chip-grid #chipGrid aria-label="Subproject selection">
        <mat-chip-row
          *ngFor="let projectId of getSelectedProjectIds().slice(0, maxChipItems); trackBy: trackByProjectId">
          {{getProjectName(projectId)}}
        </mat-chip-row>
        <mat-chip-row *ngIf="getSelectedProjectIds().length > maxChipItems" class="more-chip">
          +{{getSelectedProjectIds().length - maxChipItems}} more items
        </mat-chip-row>
      </mat-chip-grid>
    </mat-form-field>

    <!-- Dropdown (Initially Hidden) -->
    <ng-container *ngIf="this.globals.subprojects.length">
      <div #dropdown class="dropdown" *ngIf="showDropdown"
        [class.adjust-dropdown]="uniqueId === 'document-detail-subprojects'"
        [style.width]="uniqueId==='snackbar-subprojects'?'365px !important':'100%'"
        [style]="{'top': moduleName == 'issues' ? '75% !important': moduleName == 'req' ? '85% !important': moduleName == 'reports' ? '60% !important': uniqueId === 'snackbar-subprojects' ? '': uniqueId == 'document-detail-subprojects' ? 'auto !important':'100% !important' }"
        (click)="onClickDropdown()" (mousedown)="$event.preventDefault()">
        <!-- <div class="srch-stick">
                    <div class="search-box-container">
                        <i class="uil uil-search uil-icon"></i>
                        <input class="search-box" placeholder="{{'text.search_in_subprojects' | transloco}}"
                            [value]="searchTerm" (keyup)="onSearchInput($event)">
                    </div>
                </div> -->
        <div>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="width: 100%;">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node">
              <span [class]="'tree-node '+uniqueId+'-'+treeControl.dataNodes.indexOf(node)">
                <mat-divider></mat-divider>
                <div class="node-wrapper">
                  <mat-checkbox data-cy="generic-multiselect-subprojects__subproject-checkbox"
                    [checked]="isSelected(node)" [name]="'subproject-checkbox'"
                    (change)="onProjectSelect(node, $event.checked)" (mousedown)="$event.preventDefault()"
                    [disabled]="editSubproject?.id == node.id || (treeControl.getLevel(node) >= 4 && !multiSelect) || isChildOfEditSubproject(node)"></mat-checkbox>
                  <div class="node p-node"
                    [style]="{'padding-left': treeControl.getLevel(node) * 14 + 'px !important'}">
                    <span class="name-grp">
                      <span class="node-wrapper" style="position: relative;">
                        <ng-container *ngTemplateOutlet="leafNodes; context: { node: node }"></ng-container>
                        <ngx-avatars [style]="SmallAvatarCustomStyle" [name]="node.name" initialsSize="2" size="20"
                          [borderColor]="editSubproject?.name == node.name || (treeControl.getLevel(node) >= 4 && !multiSelect) || isChildOfEditSubproject(node) ? '#d5cfcf':node.color"
                          fgColor="#000000" bgColor="#FFFFFF">
                        </ngx-avatars>
                      </span>
                      <span
                        [class]="(editSubproject?.name == node.name || (treeControl.getLevel(node) >= 4 && !multiSelect) || isChildOfEditSubproject(node) && 'gry-clr') + ' fs-13'"
                        [style]="{'color': editSubproject?.name == node.name ? 'grey': (treeControl.getLevel(node) >= 4 && !multiSelect) ? 'grey':''}">{{node.name}}</span>
                    </span>
                    <span class="node">
                      <p class="lvl-p"
                        *ngIf="globals && globals.projectConfigs && (globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] || this.globals.projectConfigs['project.labels.subprojects'])">
                        {{ globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] ?
                        globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)]:
                        this.globals.projectConfigs['project.labels.subprojects'] }}
                      </p>
                      <mat-icon class="mat-icon-rtl-mirror pointer" matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name" style="visibility: hidden;">
                        {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                      </mat-icon>
                    </span>
                  </div>
                </div>
              </span>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild">
              <span [class]="'tree-node '+uniqueId+'-'+treeControl.dataNodes.indexOf(node)">
                <mat-divider></mat-divider>
                <div class="node-wrapper">
                  <mat-checkbox data-cy="generic-multiselect-subprojects__subproject-checkbox-2"
                    [checked]="isSelected(node)" [name]="'subproject-checkbox'"
                    (change)="onProjectSelect(node, $event.checked)" (mousedown)="$event.preventDefault()"
                    [disabled]="editSubproject?.name == node.name || (treeControl.getLevel(node) >= 4 && !multiSelect) || isChildOfEditSubproject(node)"></mat-checkbox>
                  <div class="node p-node"
                    [style]="{'padding-left': treeControl.getLevel(node) * 14 + 'px !important'}">
                    <span class="name-grp">
                      <span class="node-wrapper" style="position: relative;">
                        <ng-container *ngTemplateOutlet="expandableNodes; context: { node: node }"></ng-container>
                        <ngx-avatars [style]="SmallAvatarCustomStyle" [name]="node.name" initialsSize="2" size="20"
                          [borderColor]="editSubproject?.name == node.name || (treeControl.getLevel(node) >= 4 && !multiSelect) || isChildOfEditSubproject(node) ? '#d5cfcf':node.color"
                          fgColor="#000000" bgColor="#FFFFFF">
                        </ngx-avatars>
                      </span>
                      <span
                        [class]="(editSubproject?.name == node.name || (treeControl.getLevel(node) >= 4 && !multiSelect) || isChildOfEditSubproject(node) && 'gry-clr') + ' fs-13'"
                        [style]="{'color': editSubproject?.name == node.name ? 'grey': (treeControl.getLevel(node) >= 4 && !multiSelect) ? 'grey':''}">{{node.name}}</span>
                    </span>
                    <span class="node">
                      <p class="lvl-p"
                        *ngIf="globals && globals.projectConfigs && (globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] || this.globals.projectConfigs['project.labels.subprojects'])">
                        {{ globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)] ?
                        globals.projectConfigs['project.labels.subprojects.level_'+ (node.level+1)]:
                        this.globals.projectConfigs['project.labels.subprojects'] }}
                      </p>
                      <mat-icon class="mat-icon-rtl-mirror pointer" matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name">
                        {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                      </mat-icon>
                    </span>
                  </div>
                </div>
              </span>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>


<ng-container *ngIf="userSubprojects">
  <!-- Tree View -->
  <li>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">

      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <div class="node-divide-wrapper">
          <mat-divider *ngIf="treeControl.getLevel(node)==0 && !isFirstSiblingOnLvl0(node)"
            [style.margin]="'6px 0 0 0 !important'"></mat-divider>
          <div class="node-wrapper p-node"
            [style]="{'padding-left': treeControl.getLevel(node) * 26 + 'px !important'}">
            <div class="node-wrapper" style="position: relative;">
              <p class="fs-13">{{node.name}}</p>
            </div>
            <ng-container
              *ngTemplateOutlet="createSubproject ? subprojectsRoles1 : subprojectsRoles0; context: { node: node }"></ng-container>
          </div>
        </div>
      </mat-tree-node>

      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <div class="node-divide-wrapper">
          <mat-divider *ngIf="treeControl.getLevel(node)==0 && !isFirstSiblingOnLvl0(node)"
            [style.margin]="'6px 0 0 0 !important'"></mat-divider>
          <div class="node-wrapper p-node"
            [style]="{'padding-left': treeControl.getLevel(node) * 26 + 'px !important'}">
            <div class="node-wrapper">
              <div class="node-wrapper" style="position: relative;">
                <p class="fs-13">{{node.name}}</p>
              </div>
              <button data-cy="generic-multiselect-subprojects__btn" mat-icon-button type="button" matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
            </div>
            <ng-container
              *ngTemplateOutlet="createSubproject ? subprojectsRoles1 : subprojectsRoles0; context: { node: node }"></ng-container>
          </div>
        </div>
      </mat-tree-node>
    </mat-tree>
  </li>
</ng-container>

<!-- Dots Tree View -->
<ng-template #leafNodes let-node="node">
  <div class="vertical-line-detail dots-position-detail" *ngIf="treeControl.getLevel(node) > 0"></div>
  <div class="vertical-line-detail dots-position ml-dots-detail"
    *ngIf="treeControl.getLevel(node) == 4 && !isChildOfLastSibling(node)"></div>
  <div class="vertical-line-detail dots-position ml-dots-detail"
    *ngIf="(treeControl.getLevel(node) == 3 && !isChildOfLastSibling(node)) || (treeControl.getLevel(node) == 4 && !isGrandparentLastSibling(node))"
    [style.left]="treeControl.getLevel(node) == 3 ? '-13px !important' : '-27px !important'"></div>
  <div class="vertical-line-detail dots-position bottom-below-half-dots-detail"
    *ngIf="treeControl.getLevel(node) > 0 && !isLastSibling(node)"></div>
  <div class="vertical-line-detail dots-position left-dots-lvl-gt1-detail"
    *ngIf="( treeControl.getLevel(node) == 4 && !isGreatGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 3 && !isGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 2 && !isChildOfLastSibling(node))"
    [style.left]="treeControl.getLevel(node) == 2 ? '-13px !important' : treeControl.getLevel(node) == 3 ? '-27px !important' : '-41px !important'">
  </div>
  <div class="horizontal-line-detail" *ngIf="treeControl.getLevel(node) > 0"></div>
</ng-template>

<ng-template #expandableNodes let-node="node">
  <div class="vertical-line-detail dots-position-detail" *ngIf="treeControl.getLevel(node) > 0"></div>
  <div class="vertical-line-detail dots-position ml-dots-detail" *ngIf="treeControl.getLevel(node) == 4"></div>
  <div class="vertical-line-detail dots-position ml-dots-detail"
    *ngIf="(treeControl.getLevel(node) == 3 && !isChildOfLastSibling(node)) || (treeControl.getLevel(node) == 4 && !isGrandparentLastSibling(node))"
    [style.left]="treeControl.getLevel(node) ==3 ? '-13px !important' : '-27px !important'"></div>
  <div class="vertical-line-detail dots-position left-dots-lvl-gt1-detail"
    *ngIf="( treeControl.getLevel(node) == 4 && !isGreatGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 3 && !isGrandparentLastSibling(node)) || (treeControl.getLevel(node) == 2 && !isChildOfLastSibling(node))"
    [style.left]="treeControl.getLevel(node) ==2 ? '-13px !important' : treeControl.getLevel(node) == 3 ? '-27px !important':'-41px !important'">
  </div>
  <div class="vertical-line-detail dots-position bottom-below-half-dots-detail"
    *ngIf="treeControl.getLevel(node) > 0 && !isLastSibling(node)"></div>
  <div class="vertical-line-detail dots-position mid-dots-detail"
    [class.mid-dots-lvl1-detail]="treeControl.getLevel(node) == 0" *ngIf="treeControl.isExpanded(node)"></div>
  <div class="horizontal-line-detail" *ngIf="treeControl.getLevel(node) > 0"></div>
</ng-template>


<!-- Subproject Roles Template -->
<ng-template #subprojectsRoles0 let-node="node">
  <div style="width: 35vw;">
    <app-generic-multiselect-checkbox data-cy="generic-multiselect-subprojects__generic-multiselect-checkbox"
      placeholder="{{'users.roles' | transloco}}" [name]="node.name" [multiple]="false"
      [(ngModel)]="selectedSubprojectRoles[getRoleIndex(node.id)]"
      (ngModelChange)="selectedItems.emit({id: node.id, i: getRoleIndex(node.id)})">
      <app-generic-multiselect-checkbox-option *ngFor="let role of subprojectRoles" [value]="role">
        {{ role.name }}
      </app-generic-multiselect-checkbox-option>
    </app-generic-multiselect-checkbox>
  </div>
</ng-template>

<ng-template #subprojectsRoles1 let-node="node">
  <div style="width: 35vw;">
    <app-generic-multiselect-checkbox data-cy="generic-multiselect-subprojects__generic-multiselect-checkbox-2"
      placeholder="{{'users.roles' | transloco}}" [name]="node.name" [multiple]="false"
      [(ngModel)]="selectedSubprojectRoles[getRoleIndex(node.id)]"
      (ngModelChange)="selectedItems.emit({id: node.id, i: getRoleIndex(node.id)})">
      <app-generic-multiselect-checkbox-option *ngFor="let role of subprojectRoles" [value]="role">
        {{ role.name }}
      </app-generic-multiselect-checkbox-option>
    </app-generic-multiselect-checkbox>
  </div>
</ng-template>
